import { form, sourceParam } from '../../utils/variables';
import {params} from "./movePages";

export function footerListeners() {
    const isWL = form?.project?.whitelabel ?? false;
    if (isWL) return;

    let url =  params('appUrl');

    let companyUrl = url.includes('kloudmd') ? 'https://kloudmd.com': 'https://pilotpractice.com';

    document.querySelectorAll('.subFooter--4 span').forEach((i) => {
        i.onclick = () => {
            window.parent.location.href = `${companyUrl}${
                sourceParam ? `?source=${sourceParam}` : ''
            }`;
        };
    });
}
